module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("This book is dedicated to my dear friends Ted and Vada Stanley,"), _c('br'), _vm._v("for being there for me, and whose friendship, love, and support"), _c('br'), _vm._v("throughout the years continues to be cherished.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507a4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 66
// module chunks = 0